import { Form } from "components/Forms";
import { buildWidgetInstanceId } from "features/widgets";
import { WIDGETS_REGISTRY } from "features/widgets/widgets.config";
import { Container } from "shared/components";
import { useCollectedData } from "shared/contexts/PageData";

import styles from "./LayoutWidget066.module.scss";

export const LayoutWidget066 = ({ payload }) => {
  const instanceId = buildWidgetInstanceId(
    "l066",
    payload.id,
    WIDGETS_REGISTRY["LAYOUT-WIDGET"]
  );
  const { forms } = useCollectedData(instanceId, [
    { name: "forms", defaultValue: [] },
  ]);

  const [form] = forms;

  return (
    <div className={styles.wrapper}>
      <Container>
        <Form item={form} instanceId={instanceId} />
      </Container>
    </div>
  );
};

export default LayoutWidget066;
